import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import Header from './components/Header'
import Main from './views/Main'
import Footer from './components/Footer'
import Intro from './views/Intro'
import { RecoilRoot, useSetRecoilState } from 'recoil'
import { getProfile } from 'apis/user'
import { useEffect } from 'react'
import { userState } from 'stores/userState'

function CommonAuth({ children }) {
  const location = useLocation()
  const setUser = useSetRecoilState(userState)
  useEffect(() => {
    async function getProfileApi() {
      const getProfileRes = await getProfile()
      console.log(getProfileRes)
      if (getProfileRes.error || !getProfileRes.data) {
        setUser({
          isLogin: false,
          name: '',
          userType: '',
          school: '',
        })
      } else {
        setUser({
          isLogin: true,
          name: getProfileRes.data.name,
          userType: getProfileRes.data.userType,
          school: getProfileRes.data.school,
        })
      }
    }
    getProfileApi()
    // eslint-disable-next-line
  }, [location])
  return children
}

function App() {
  return (
    <div className='App'>
      <RecoilRoot>
        <Router>
          <Header />
          <Routes>
            <Route
              path='/'
              element={
                <CommonAuth>
                  <Main />
                </CommonAuth>
              }
            ></Route>
            <Route
              path='/intro'
              element={
                <CommonAuth>
                  <Intro />
                </CommonAuth>
              }
            ></Route>
          </Routes>
          <Footer />
        </Router>
      </RecoilRoot>
    </div>
  )
}

export default App
